import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {APIEventSystem} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {StateMatrixCoordinate} from "../../../game/utils/StateMatrix";
import {LayersSet} from "../../../game/reels/LayersSet";

/**
 * Created by jonas on 2022-06-10.
 */

export interface SimpleReelModelEventData {
    reel:number;
    state:SimpleReelModelState;
}

export interface SimpleReelModelSymbolData {
    name:string;
    positionable:Positionable;
    reelPosition:number;
    removed:boolean;
    reelId:number;
}

export enum SimpleSymbolState {
    DROP_IN = "DROP_IN",
    DROP_OUT = "DROP_OUT",
    NORMAL = "NORMAL",
    COLLAPSE_L2R = "COLLAPSE_L2R",
    COLLAPSE_R2L = "COLLAPSE_R2L",
    LANDING = "LANDING",
}

export enum SimpleReelModelState {
    IDLE = "IDLE",
    START = "START",
    SPIN = "SPIN",
    STOP = "STOP",
    STOPPED = "STOPPED",
    BOUNCE = "BOUNCE",
    WIND_UP = "WIND_UP",
    NUDGE = "NUDGE",
    STICKY = "STICKY",
    FILL_UP = "FILL_UP"
}

export class Coordinate2d {
    x:number;
    y:number;

    public static fromTuple(tuple:[number,number]):Coordinate2d {
        return {x:tuple[0], y:tuple[1]};
    }

    public static fromTuples(tuples:[number,number][]):Coordinate2d[] {
        const result:Coordinate2d[] = [];
        for (let tuple of tuples){
            result.push(Coordinate2d.fromTuple(tuple));
        }
        return result;
    }

    static fromStateMatrixCoord(stateCoord:StateMatrixCoordinate) {
        return {x:stateCoord.column, y:stateCoord.row};
    }

    static fromStateMatrixCoords(stateCoords:StateMatrixCoordinate[]) {
        const result:Coordinate2d[] = [];
        for (let stateCoord of stateCoords){
            result.push(Coordinate2d.fromStateMatrixCoord(stateCoord));
        }
        return result;
    }
}



export interface Positionable {
    position:Coordinate2d;
    setAvalancheState(state:SimpleSymbolState):void;
}

export interface SimpleReelModelSymbolPosition {
    reelID:number;
    position:number
}

export interface SimpleReelModelDelegate {
    createSymbol(symbolName:string, state:SimpleReelModelState, position:SimpleReelModelSymbolPosition):Positionable;
    removeSymbol(symbolData:SimpleReelModelSymbolData):void;
}

export interface ReelView {
    layers: LayersSet,
}

export class SimpleReelModel {



    public readonly events:APIEventSystem | undefined;
    public readonly id:number;
    protected _delegate:SimpleReelModelDelegate;

    constructor(id:number, delegate:SimpleReelModelDelegate, triggerEvents:boolean = false) {
        this.id = id;
        this._delegate = delegate;
        if (triggerEvents) {
            this.events = SlotGame.apiPlugin.eventSystemFactory.create();
            this.events.on("ReelStateChange", (data:SimpleReelModelEventData) => this.onReelStateChange(data)); //To prevent event system from saving once callbacks if no on callbacks is set.
        }
    }

    private onReelStateChange(data:SimpleReelModelEventData):void {
        this.events?.trigger(data.state, data);
    }

    protected createNewSymbol(name:string, position:number, state:SimpleReelModelState):SimpleReelModelSymbolData {
        return {
            name:name,
            positionable:this._delegate.createSymbol(name, state, {reelID:this.id, position:position}),
            reelPosition:position,
            removed: false,
            reelId:this.id
        }
    }

    protected clearSymbols(symbols:SimpleReelModelSymbolData[]):void {
        let symbol;
        while (symbol = symbols.pop()) {
            this._delegate.removeSymbol(symbol);
        }
    }
}